import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationOilDiscountCounter } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
export default {
  name: 'SlotCounterStationDiscountSheet',
  components: {},
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    refIndex: {
      type: Number,
      required: true
    },
    sheetType: {
      type: String,
      required: true
    },
    slotCounterName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      slotOption: '',
      selectedOilCode: '92',
      selectedArea: '全部',
      dayNums: 0,
      monthNums: 0,
      daySumSvcNums: 0,
      daySumUserNums: 0,
      daySumPlatformNums: 0,
      monthSumSvcNums: 0,
      monthSumUserNums: 0,
      monthSumPlatformNums: 0,
      groupData: [],
      renderData: [],
      borderFix: ['合计/L', '合/L', '0#'],
      cellColClassFix: ['monthSumUserNums', 'monthGoodsPrice', 'monthAvgUserPrice', 'monthDiffUserPrice', 'monthSumSvcNums', 'monthAvgSvcPrice', 'monthDiffSvcPrice', 'monthSumPlatformNums', 'monthAvgPlatformPrice', 'monthDiffPlatformPrice'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }]
    };
  },
  watch: {
    end: function end() {
      this.loadMemberDiscountData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadMemberDiscountData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs['tableStationDiscountSale' + _this.sheetType].doLayout();
    });
  },
  methods: {
    selectedChange: function selectedChange() {
      this.renderData = this.groupDataFilter(this.selectedOilCode);
    },
    refIndexRefresh: function refIndexRefresh() {
      this.$refs['tableStationDiscountSale' + this.sheetType].doLayout();
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    npPercent: function npPercent(a, b) {
      return NP.round(NP.times(NP.divide(NP.minus(Number(a), Number(b)), b), 100), 2);
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    percentFormat: function percentFormat(value1, value2) {
      return value2 === 0 ? '--' : NP.round(NP.divide(value1, value2) * 100, 2) + '%';
    },
    numsFormat: function numsFormat(value) {
      return NP.round(NP.divide(value, 10000), 2);
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    getSummaries: function getSummaries(param) {
      var _this2 = this;

      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values;

        if (_this2.sheetType === 'user' && column.property === 'dayUserGoodsPrice') {
          values = data.map(function (item) {
            return NP.times(item['dayUserGoodsPrice'], item['daySumUserNums']);
          });
        } else if (_this2.sheetType === 'svc' && column.property === 'daySvcGoodsPrice') {
          values = data.map(function (item) {
            return NP.times(item['daySvcGoodsPrice'], item['daySumSvcNums']);
          });
        } else if (_this2.sheetType === 'platform' && column.property === 'dayPlatformGoodsPrice') {
          values = data.map(function (item) {
            return NP.times(item['dayPlatformGoodsPrice'], item['daySumPlatformNums']);
          });
        } else if (_this2.sheetType === 'user' && column.property === 'dayGoodsOriginal') {
          values = data.map(function (item) {
            return NP.times(item['dayGoodsOriginal'], item['daySumUserNums']);
          });
        } else if (_this2.sheetType === 'svc' && column.property === 'dayGoodsOriginal') {
          values = data.map(function (item) {
            return NP.times(item['dayGoodsOriginal'], item['daySumSvcNums']);
          });
        } else if (_this2.sheetType === 'platform' && column.property === 'dayGoodsOriginal') {
          values = data.map(function (item) {
            return NP.times(item['dayGoodsOriginal'], item['daySumPlatformNums']);
          });
        } else if (column.property === 'dayAvgUserPrice') {
          values = data.map(function (item) {
            return NP.times(item['dayAvgUserPrice'], item['daySumUserNums']);
          });
        } else if (column.property === 'dayAvgSvcPrice') {
          values = data.map(function (item) {
            return NP.times(item['dayAvgSvcPrice'], item['daySumSvcNums']);
          });
        } else if (column.property === 'dayAvgPlatformPrice') {
          values = data.map(function (item) {
            return NP.times(item['dayAvgPlatformPrice'], item['daySumPlatformNums']);
          });
        } else if (_this2.sheetType === 'user' && column.property === 'monthUserGoodsPrice') {
          values = data.map(function (item) {
            return NP.times(item['monthUserGoodsPrice'], item['monthSumUserNums']);
          });
        } else if (_this2.sheetType === 'svc' && column.property === 'monthSvcGoodsPrice') {
          values = data.map(function (item) {
            return NP.times(item['monthSvcGoodsPrice'], item['monthSumSvcNums']);
          });
        } else if (_this2.sheetType === 'platform' && column.property === 'monthPlatformGoodsPrice') {
          values = data.map(function (item) {
            return NP.times(item['monthPlatformGoodsPrice'], item['monthSumPlatformNums']);
          });
        } else if (_this2.sheetType === 'user' && column.property === 'monthGoodsOriginal') {
          values = data.map(function (item) {
            return NP.times(item['monthGoodsOriginal'], item['monthSumUserNums']);
          });
        } else if (_this2.sheetType === 'svc' && column.property === 'monthGoodsOriginal') {
          values = data.map(function (item) {
            return NP.times(item['monthGoodsOriginal'], item['monthSumSvcNums']);
          });
        } else if (_this2.sheetType === 'platform' && column.property === 'monthGoodsOriginal') {
          values = data.map(function (item) {
            return NP.times(item['monthGoodsOriginal'], item['monthSumPlatformNums']);
          });
        } else if (column.property === 'monthAvgUserPrice') {
          values = data.map(function (item) {
            return NP.times(item['monthAvgUserPrice'], item['monthSumUserNums']);
          });
        } else if (column.property === 'monthAvgSvcPrice') {
          values = data.map(function (item) {
            return NP.times(item['monthAvgSvcPrice'], item['monthSumSvcNums']);
          });
        } else if (column.property === 'monthAvgPlatformPrice') {
          values = data.map(function (item) {
            return NP.times(item['monthAvgPlatformPrice'], item['monthSumPlatformNums']);
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      sums[2] = sums[1] > 0 ? NP.round(NP.divide(sums[2], sums[1]), 2) : '-';
      sums[3] = sums[1] > 0 ? NP.round(NP.divide(sums[3], sums[1]), 2) : '-';
      sums[4] = sums[1] > 0 ? NP.round(NP.divide(sums[4], sums[1]), 2) : '-';
      sums[5] = sums[1] > 0 ? NP.minus(sums[2], sums[4]) : '-';
      sums[7] = sums[6] > 0 ? NP.round(NP.divide(sums[7], sums[6]), 2) : '-';
      sums[8] = sums[6] > 0 ? NP.round(NP.divide(sums[8], sums[6]), 2) : '-';
      sums[9] = sums[6] > 0 ? NP.round(NP.divide(sums[9], sums[6]), 2) : '-';
      sums[10] = sums[6] > 0 ? NP.minus(sums[7], sums[9]) : '-';
      return sums;
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    loadMemberDiscountData: function loadMemberDiscountData() {
      var _this3 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: parseInt(this.sheetType),
          name: this.slotCounterName,
          start: this.end / 1000 - 24 * 60 * 60,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      this.dayNums = 0;
      this.monthNums = 0;
      this.daySumSvcNums = 0;
      this.daySumUserNums = 0;
      this.daySumPlatformNums = 0;
      this.monthSumSvcNums = 0;
      this.monthSumUserNums = 0;
      this.monthSumPlatformNums = 0;
      getStationOilDiscountCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this3.groupData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        });
        _this3.loading = false;
        _this3.renderData = _this3.groupDataFilter(_this3.selectedOilCode);
        var _that = _this3;

        _this3.groupData.forEach(function (ele) {
          _that.dayNums = NP.plus(_that.dayNums, ele.dayNums);
          _that.monthNums = NP.plus(_that.monthNums, ele.monthNums);
          _that.daySumSvcNums = NP.plus(_that.daySumSvcNums, ele.daySumSvcNums);
          _that.daySumUserNums = NP.plus(_that.daySumUserNums, ele.daySumUserNums);
          _that.daySumPlatformNums = NP.plus(_that.daySumPlatformNums, ele.daySumPlatformNums);
          _that.monthSumSvcNums = NP.plus(_that.monthSumSvcNums, ele.monthSumSvcNums);
          _that.monthSumUserNums = NP.plus(_that.monthSumUserNums, ele.monthSumUserNums);
          _that.monthSumPlatformNums = NP.plus(_that.monthSumPlatformNums, ele.monthSumPlatformNums);
        });

        _this3.$refs['tableStationDiscountSale' + _this3.sheetType].doLayout();
      }).catch(function () {
        _this3.loading = false;
      });
    },
    groupDataFilter: function groupDataFilter(oilCode) {
      var renderArr = [];
      this.groupData.forEach(function (el) {
        if (oilCode === el.oilCode) {
          renderArr.push(el);
        }
      });
      return renderArr;
    },
    timestamp2datestring: function timestamp2datestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return dateUtils.timeStampToString(ts, format);
    },
    timestamp2beforemonthdatestring: function timestamp2beforemonthdatestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      return dateUtils.timeStampToBeforeMonthString(ts, format, n);
    },
    timestamp2beforeyeardatestring: function timestamp2beforeyeardatestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      return dateUtils.timeStampToBeforeYearString(ts, format, n);
    }
  }
};